<template>
  <div data-server-rendered="true" id="__nuxt" class="page-root">
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <!-- 顶部横幅：高级感全屏 Banner -->
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo-area">
                    <div class="logo"/>

                  </div>
                  <div class="right-actions">
                    <div class="auth-buttons">
                      <div class="btn-auth" v-if="!loginTrue" @click="loginUp()">
                        登录/注册
                      </div>
                      <div class="btn-auth" v-if="loginTrue" @click="logout">
                        退出
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 主体内容：纯净现代白底设计 -->
          <div class="concept-main">
            <div class="page_width">
              <div class="bord" v-if="hisShow">
                <!-- 加载遮罩 -->
                <div v-if="isLoading" class="loading-container">
                  <div class="loadingGif fade-in">
                    <loading/>
                    <div class="loading-text">报告生成中...</div>
                    <div class="loading-subtext">该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</div>
                  </div>
                </div>

                <!-- 核心评估区域：先展示核心功能，再引导填写评估申请 -->
                <el-card v-if="!isLoading && !textShow" class="page-card" shadow="never">
                  <div class="page-card-inner">
                    <!-- 顶部：核心功能与服务价值 -->
                    <section class="modern-card info-section">
                      <div class="card-header">
                        <span class="header-indicator"></span>
                        <h2>核心功能</h2>
                      </div>
                      <p class="card-paragraph">
                        概念验证评估中心面向高校院所、科技企业及科研团队，提供从“技术可行性论证”到“商业化落地路径规划”的一站式智能评估服务，
                        帮助成果在早期阶段就看清技术价值与市场空间，提升决策效率。
                      </p>
                      <ul class="clean-list">
                        <li>
                          <i class="el-icon-circle-check"></i>
                          <span>基于前沿AI技术大数据的专业评估体系，量化项目可行性</span>
                        </li>
                        <li>
                          <i class="el-icon-circle-check"></i>
                          <span>多维度指标对齐，精准识别技术转化核心风险点</span>
                        </li>
                        <li>
                          <i class="el-icon-circle-check"></i>
                          <span>模拟实际应用场景，构建成果转化路径与商业模型</span>
                        </li>
                        <li>
                          <i class="el-icon-circle-check"></i>
                          <span>提供优化性评估意见，降低验证成本并提升评估效率</span>
                        </li>
                      </ul>

                      <!-- 小图表展示区：增强数据感 -->
                      <div class="mini-charts-grid">
                        <div class="mini-chart-item">
                          <div class="chart-icon chart-icon--radar">
                            <svg viewBox="0 0 100 100">
                              <polygon points="50,5 90,35 75,85 25,85 10,35" fill="none" stroke="currentColor"
                                       stroke-width="2" opacity="0.3"/>
                              <polygon points="50,20 80,45 65,75 35,75 20,45" fill="rgba(37, 99, 235, 0.2)"
                                       stroke="#2563eb" stroke-width="2"/>
                            </svg>
                          </div>
                          <div class="chart-info">
                            <span class="label">技术创新度</span>
                            <span class="value">92%</span>
                          </div>
                        </div>
                        <div class="mini-chart-item">
                          <div class="chart-icon chart-icon--bar">
                            <svg viewBox="0 0 100 100">
                              <rect x="10" y="60" width="15" height="30" fill="#10b981" rx="2"/>
                              <rect x="35" y="40" width="15" height="50" fill="#10b981" rx="2"/>
                              <rect x="60" y="20" width="15" height="70" fill="#10b981" rx="2"/>
                              <rect x="85" y="50" width="15" height="40" fill="#10b981" rx="2"/>
                            </svg>
                          </div>
                          <div class="chart-info">
                            <span class="label">市场匹配度</span>
                            <span class="value">88%</span>
                          </div>
                        </div>
                        <div class="mini-chart-item">
                          <div class="chart-icon chart-icon--trend">
                            <svg viewBox="0 0 100 100">
                              <path d="M10,80 Q30,70 50,40 T90,20" fill="none" stroke="#f59e0b" stroke-width="3"
                                    stroke-linecap="round"/>
                              <circle cx="90" cy="20" r="4" fill="#f59e0b"/>
                            </svg>
                          </div>
                          <div class="chart-info">
                            <span class="label">预期收益率</span>
                            <span class="value">+240%</span>
                          </div>
                        </div>
                      </div>

                      <div class="divider-line"></div>

                      <div class="card-header">
                        <span class="header-indicator header-indicator--blue"></span>
                        <h2>服务价值</h2>
                      </div>
                      <div class="value-grid">
                        <div class="value-item">
                          <div class="value-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <path fill="#2563eb"
                                    d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"/>
                              <path fill="#2563eb"
                                    d="M12 6a1 1 0 0 0-1 1v3.59l-1.3-1.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l3-3a1 1 0 0 0-1.4-1.42L13 10.59V7a1 1 0 0 0-1-1z"/>
                            </svg>
                          </div>
                          <div class="value-text">
                            <h4>精准评估</h4>
                            <p>多维量表量化可行性</p>
                          </div>
                        </div>
                        <div class="value-item">
                          <div class="value-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <path fill="#2563eb"
                                    d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12c5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
                            </svg>
                          </div>
                          <div class="value-text">
                            <h4>风险规避</h4>
                            <p>识别成果转化核心风险</p>
                          </div>
                        </div>
                        <div class="value-item">
                          <div class="value-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <path fill="#2563eb"
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V9h2v7zm4 0h-2V7h2v9z"/>
                            </svg>
                          </div>
                          <div class="value-text">
                            <h4>加速转化</h4>
                            <p>缩短从实验室到市场路径</p>
                          </div>
                        </div>
                        <div class="value-item">
                          <div class="value-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <path fill="#2563eb"
                                    d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
                            </svg>
                          </div>
                          <div class="value-text">
                            <h4>降本增效</h4>
                            <p>降低研发验证试错成本</p>
                          </div>
                        </div>
                      </div>

                      <div class="core-target-grid">
                        <div class="core-target-item">
                          <h4>适用对象</h4>
                          <p>拟申请各级科技计划项目、成果转化基金、产业化专项的科技成果团队。</p>
                        </div>
                        <div class="core-target-item">
                          <h4>典型场景</h4>
                          <p>立项前可行性论证、投融资路演准备、与企业对接前的技术价值梳理等。</p>
                        </div>
                        <div class="core-target-item">
                          <h4>输出形式</h4>
                          <p>结构化HTML评估报告，可直接用于申报附件、项目路演或内部决策材料。</p>
                        </div>
                      </div>
                    </section>

                    <!-- 中部：项目评估申请（单独一块） -->
                    <div class="evaluation-grid evaluation-grid--single">
                      <!-- 申请表单卡片 -->
                      <section class="modern-card form-section">
                        <div class="form-header-group">
                          <div class="form-icon-box">
                            <i class="el-icon-edit-outline"></i>
                          </div>
                          <div class="form-title-text">
                            <h3>项目验证报告申请</h3>
                            <p>请填写以下信息，系统将智能生成概念验证评估报告</p>
                          </div>
                        </div>

                        <el-form
                            ref="form"
                            :model="sizeForm"
                            :rules="formRules"
                            label-position="top"
                            class="clean-form"
                        >
                          <el-form-item label="项目/成果名称" prop="achievementName">
                            <el-input v-model="sizeForm.achievementName" placeholder="请输入成果名称"/>
                          </el-form-item>

                          <el-form-item label="核心技术原理" prop="coreTechnology">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4 }"
                                v-model="sizeForm.coreTechnology"
                                placeholder="描述该技术的原理机制"
                            />
                          </el-form-item>

                          <el-form-item label="技术关键点" prop="breakthrough">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4 }"
                                v-model="sizeForm.breakthrough"
                                placeholder="描述优势与创新点"
                            />
                          </el-form-item>

                          <el-form-item label="解决主要问题" prop="solve">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4 }"
                                v-model="sizeForm.solve"
                                placeholder="描述解决的问题/痛点"
                            />
                          </el-form-item>

                          <el-form-item label="预计研发投入" prop="investment">
                            <div class="input-with-extra">
                              <el-input
                                  type="number"
                                  v-model="sizeForm.investment"
                                  placeholder="金额"
                              >
                                <template slot="append">万元</template>
                              </el-input>
                              <div class="input-badge">10万元起评</div>
                            </div>
                          </el-form-item>
                        </el-form>

                        <button class="premium-button" type="button" @click="submitForm">
                          <span>立即智能评估</span>
                          <i class="el-icon-magic-stick"></i>
                        </button>
                      </section>
                    </div>

                    <!-- 评估说明与小贴士：使用 el-card 单独展示 -->
                    <el-card class="guide-card" shadow="hover">
                      <section class="guide-section">
                        <div class="card-header">
                          <span class="header-indicator header-indicator--blue"></span>
                          <h2>如何快速获得一份高质量评估报告？</h2>
                        </div>
                        <p class="card-paragraph">
                          建议在填写信息前，先整理一份不超过1页的技术简介，包括“技术解决什么问题”“相比传统方案有哪些提升”“目前做到什么阶段”等核心要点，
                          这样系统可以更准确地理解您的成果特征。
                        </p>
                        <div class="tips-grid">
                          <div class="tip-item">
                            <h4>01 精准描述技术</h4>
                            <p>尽量使用通俗但专业的语言说明原理，避免只给出论文题目或项目名称。</p>
                          </div>
                          <div class="tip-item">
                            <h4>02 补充关键参数</h4>
                            <p>例如效率提升比例、成本变化、精度水平等，有助于生成更直观的对比分析。</p>
                          </div>
                          <div class="tip-item">
                            <h4>03 明确目标场景</h4>
                            <p>简单说明未来希望应用在哪些行业、哪些典型场景，方便系统匹配市场空间。</p>
                          </div>
                        </div>
                        <div class="divider-line divider-line--spaced"></div>
                        <div class="faq-list">
                          <div class="faq-item">
                            <h4>报告生成需要多久？</h4>
                            <p>根据内容复杂度，一般在 <strong>1-2 分钟</strong> 内完成，请耐心等待系统计算与排版。</p>
                          </div>
                          <div class="faq-item">
                            <h4>是否可以多次生成？</h4>
                            <p>可以。您可以针对同一成果多次调整描述和参数，多版本对比不同评估结论。</p>
                          </div>
                        </div>
                      </section>
                    </el-card>

                  </div>
                </el-card>

                <!-- 报告结果展示 -->
                <div id="myapp" v-if="textShow" ref="messageContainer">
                  <div class="report-status">
                    <i class="el-icon-success"></i>
                    <span>评估报告已生成</span>
                  </div>
                  <AdaptiveIframe
                      :src="htmlUrl"
                      custom-class="concept-iframe"
                      :min-height="1000"
                      :height-margin="0"
                      :retry-count="1"
                      :retry-interval="1000"
                      @height-changed="onIframeHeightChanged"
                  />
                  <div class="report-actions">
                    <button class="refreshPageClass" @click="refreshPage">
                      <span>重新查询</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- 历史评估记录 -->
              <div class="history-content" v-else>
                <div class="history-header">
                  <i class="el-icon-collection"></i>
                  <span>历史评估记录</span>
                </div>
                <div class="table-wrapper">
                  <el-table :data="tableData" style="width: 100%" class="custom-table">
                    <el-table-column prop="reportPath" label="报告名称"/>
                    <el-table-column prop="createTime" label="生成日期" width="200" align="center"/>
                    <el-table-column label="操作" width="120" align="center">
                      <template #default="scope">
                        <el-button type="text" class="text-blue" @click="handleDown(scope.row)">
                          下载
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pagination-container">
                    <el-pagination
                        layout="prev, pager, next, total"
                        :total="total"
                        background
                        @current-change="changePage"
                    />
                  </div>
                </div>
                <el-empty v-if="showEmpty" description="暂无历史数据"/>
              </div>
            </div>
          </div>
          <div style="background: #252525">
            <img
                src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
                alt
                class="foot_bg"
            />
            <div class="website">
              <div class="max_wid">
                <div class="max_lef">
                  <div class="labe2">
                    通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                  </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      主办单位：泰山科技大市场
                      <span class="footer-view-count">
                        <i class="el-icon-view"></i>
                        <span class="footer-view-text">{{ viewCount }} 浏览</span>
                      </span>
                    </div>
                    <div class="labe2Right">技术支持：0538-8265266</div>
                  </div>
                </div>
                <div class="max_rig">
                  <!--              <div class="label">服务电话：</div>-->
                  <div class="labe2">联系方式：18953878448</div>
                  <div class="labe2">邮编：271000</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import {getToken, visit} from "@/api/http";
import {getConceptList, getHtml, addConceptRecord, editConceptRecord} from "@/api/concept";
import test from "@/views/test.vue";
import loading from "@/components/loading.vue";
import AdaptiveIframe from "@/components/AdaptiveIframe.vue";

export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin,
    test,
    loading,
    AdaptiveIframe,
  },
  data() {
    return {
      viewCount: 0,
      htmlUrl: "",
      url: "wss://kejichengguo.tskjdsc.com/WebSocketDocGenerator/WebSocketDocGenerator/message",
      message: " ",
      text_content: "",
      ws: null,
      sizeForm: {
        achievementName: "",
        coreTechnology: "",
        breakthrough: "",
        solve: "",
        investment: "",
      },
      textShow: false,
      isLoading: false,
      hisShow: true,
      loginTrue: "",
      achievementName: "",
      text: "",
      keywords: ["企业概况"],
      output: "",
      token: "",
      pageSize: 10,
      pageNum: 1,
      total: 0,
      showDown: false,
      showDownUrl: "",
      showEmpty: false,
      tableData: [],
      formRules: {
        achievementName: [{required: true, message: "请输入成果名称", trigger: "blur"}],
        coreTechnology: [{required: true, message: "请输入核心技术原理", trigger: "blur"}],
        breakthrough: [{required: true, message: "请输入技术突破点", trigger: "blur"}],
        solve: [{required: true, message: "请输入解决的问题", trigger: "blur"}],
        investment: [{required: true, message: "请输入预计研发投入", trigger: "blur"}],
      },
    };
  },
  mounted() {
    this.initViewCount();
  },
  created() {
    this.getToken();
    this.login();
  },
  methods: {

    async initViewCount() {
      const pageKey = this.$route?.path || "ZhiqiTong";
      try {
        const res = await visit({pageKey});
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === "number") {
          this.viewCount = data;
        }
      } catch (e) {
        console.error("浏览量上报失败", e);
      }
    },
    onIframeHeightChanged() {
    },
    refreshPage() {
      window.location.reload();
    },
    getTokeNew() {
      getToken().then((response) => {
        this.token = response.data;
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.send();
        } else {
          return false;
        }
      });
    },
    send() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      } else {
        // this.message="请以科技成果概念验证中心的视角，对完全防火保持常温的消防专用绳技术进行专业的商业化评估，" +
        //     "并且总结并生成完整的HTML格式的分析报告，内容需包含以下模块:\n" +
        //     "一、技术核心信息技术名称：完全防火保持常温的消防专用绳核心原理：基于多层复合材料设计与热管理技术的结合，通过物理隔离、热反射、相变吸热及材料阻燃性等机制实现防火与常温保持。\n" +
        //     "突破点：在于通过材料创新、结构优化与热管理机制的深度融合，突破传统消防绳在极端高温下易失效、温度传导快的瓶颈。\n" +
        //     "解决痛点：消防场景中高温环境对绳索性能的破坏、操作人员安全风险、救援效率受限三大核心问题，同时兼顾复杂火场环境下的多功能需求研发投入：1000\n" +
        //     "交付要求:\n" +
        //     "内容丰富一些，样式华丽一些、文字多一些，需要一些稳定输出的图片、实现图文结合、需要完成不间断的HTML文件（无外部资源链接）。\n" +
        //
        //     "注意：结尾必须要有html的结束标志，不要出现日期，尽量图文并茂，一定要保证图片可见，一定要保持稳定性、不要出现空白图的情况" +
        //     "不可以出现图片为空白的情况，生成图仅使用原生SVG/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）关键数据加粗变色"
        this.message = "" +
            "请以科技成果概念验证中心视角，对" + this.sizeForm.achievementName +
            "技术进行商业化评估，生成HTML格式分析报告，内容需包含以下模块:" +
            "一、技术核心信息" +
            "技术名称：" + this.sizeForm.achievementName +
            "核心原理：" + this.sizeForm.coreTechnology +
            "突破点：" + this.sizeForm.breakthrough +
            "解决痛点：" + this.sizeForm.solve +
            "研发投入：" + this.sizeForm.investment +
            "二、评估维度分析\n" +
            "技术创新性\n" +
            "对比分析：当前市场同类技术/替代方案对比表\n" +
            "差异化优势：用雷达图展示技术参数对比（如效率/成本/精度）\n" +
            "技术可行性\n" +
            "科学原理验证：原理示意图（SVG绘制）\n" +
            "技术成熟度：TRL等级评估（1-9级）\n" +
            "实验数据：关键指标折线图（如3次迭代测试结果）\n" +
            "商业潜力\n" +
            "市场需求：目标市场规模柱状图（近5年数据）\n" +
            "客户画像：潜在客户行业分布饼图\n" +
            "支付意愿：调研数据百分比堆叠图\n" +
            "实施风险\n" +
            "风险矩阵图：概率/影响双维度评估\n" +
            "关键风险点：研发投入超支预警线图示\n" +
            "财务分析\n" +
            "成本结构：研发/生产/营销占比环形图\n" +
            "收益预测：3年ROI折线预测图\n" +
            "盈亏平衡点：销量-成本交叉分析图\n" +
            "创新等级\n" +
            "专利布局：已申请/拟申请专利数量柱状图\n" +
            "技术代际：与行业基准技术参数对比表\n" +
            "知产保护\n" +
            "保护策略：专利组合构建路径图\n" +
            "侵权风险点：高风险领域热力图\n" +
            "转化路径\n" +
            "市场化路线：B2B/B2C等模式对比图\n" +
            "推广渠道：线上线下渠道成本效益分析表\n" +
            "潜在客户：列举5家目标客户（行业+规模）\n" +
            "三、设计规范\n" +
            "页面布局：宽度1200px居中，模块化设计\n" +
            "图表规范：\n" +
            "所有图表宽度≤800px，高度≤300px\n" +
            "优先使用SVG矢量图\n" +
            "四、交付要求\n" +
            "文字尽量多一些，内容丰富一些"+
            "完整HTML文件（无外部资源链接），内容不需要非常多，注意：结尾必须要有html的结束标志，尽量图文并茂，\n" +
            "如果没有数据支撑可以不需要生成图" +
            "仅使用原生SVG/Canvas/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）" +
            "关键数据加粗变色，可以使用多种颜色避免颜色单一，确保图表清晰可辨，" +
            "不要出现任何时间相关的内容，不要出现时间戳，不要出现日期，不要出现时间，不要出现任何时间相关的内容"

        this.isLoading = true;
        this.textShow = false;

        // 先调用新增记录接口
        const userId = localStorage.getItem("userId");
        addConceptRecord({
          userId: userId,
          projectName: this.sizeForm.achievementName
        }).then((addResponse) => {
          console.log("新增概念报告记录成功", addResponse);
          const recordId = addResponse && (addResponse.data?.id || addResponse.id);
          console.log("获取到的recordId:", recordId);

          // 继续执行查询
          getHtml({concat: this.message.replaceAll("%", ""),stream:"false"}).then((res) => {
            if (res.code === 200) {
              this.htmlUrl = res.data;
              this.isLoading = false;
              this.textShow = true;

              // 数据加载完成后，调用更新记录接口
              if (recordId) {
                editConceptRecord({
                  id: recordId,
                  responseTime: new Date().getTime()
                }).then((editResponse) => {
                  console.log("更新概念报告记录响应:", editResponse);
                }).catch((editError) => {
                  console.error("更新概念报告记录失败", editError);
                });
              }
            } else {
              this.$message({
                message: '请求失败',
                type: "error",
              });
            }
          });
        }).catch((addError) => {
          console.error("新增概念报告记录失败", addError);
          // 即使新增记录失败，也继续执行查询
          getHtml({concat: this.message.replaceAll("%", "")}).then((res) => {
            if (res.code === 200) {
              this.htmlUrl = res.data;
              this.isLoading = false;
              this.textShow = true;
            } else {
              this.$message({
                message: '请求失败',
                type: "error",
              });
            }
          });
        });
      }
    },
    login() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      }
    },
    hisShowChange() {
      this.hisShow = false;
    },
    myInformation() {
      this.hisShowChange();
      let params = {pageSize: this.pageSize, pageNum: this.pageNum};
      getConceptList(params).then((response) => {
        if (response.code === 200) {
          this.tableData = response.rows;
          this.total = response.total;
          this.showEmpty = response.rows.length === 0;
        } else {
          this.$message({message: response.msg, type: "error"});
        }
      });
    },
    changePage(ele) {
      this.pageNum = ele;
      this.myInformation();
    },
    handleDown(row) {
      this.showDownUrl = row.reportPath;
      const link = document.createElement("a");
      link.href = row.reportPath;
      link.download = "评估报告.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    loginUp() {
      this.$router.push({path: "/login", query: {type: "6"}});
    },
    logout() {
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = false;
      this.$router.push({path: "/login", query: {type: "6"}});
    },
    getToken() {
      if (localStorage.getItem("token")) {
        this.loginTrue = true;
      } else {
        this.loginTrue = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">

::v-deep .refreshPageClass {
  font-size: 22px;
  margin-top: 30px;
  border-radius: 10px;
  width: 200px;
  height: 40px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 40%;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.footer-view-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  margin-left: 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  font-size: 14px;
  color: #e5e5e5;

  i {
    font-size: 16px;
  }
}

.footer-view-text {
  font-size: 14px;
}

/* --- 全局样式变量 --- */
$primary: #2563eb;
$primary-light: #eff6ff;
$bg-body: #f8fafc;
$text-dark: #1e293b;
$text-light: #64748b;
$border: #e2e8f0;
$radius: 20px;
$shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 15px -5px rgba(0, 0, 0, 0.03);

.page-root {
  min-height: 100vh;
  background: $bg-body;
  color: $text-dark;
  font-family: -apple-system, "SF Pro SC", "HanHei SC", "PingFang SC", "Arial", sans-serif;
  width: 100%;
  margin: 0;
  padding: 0;
}

:global(html),
:global(body),
:global(#__nuxt),
:global(#__layout),
:global(.index_body) {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  max-width: none !important;
  overflow-x: hidden;
}

.page_width {
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

.banner_box {
  width: 100%;
  background-image: url("~@/assets/img/gainian.png");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  aspect-ratio: 1920 / 480;
  display: flex;
  position: relative;
  min-height: 400px;
  padding: 24px 0 190px;
  box-sizing: border-box;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 17px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  margin-top: 20px;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
  .btn1 {
    position: absolute;
    left: 380px;
  }
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;
}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  background-image: url("~@/assets/img/logn.png");
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
}

.logo img {
  height: 48px;
  width: auto;
  display: block;
}


.right-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.view-count-badge {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 16px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  border-radius: 24px;
  font-size: 20px;
  line-height: 23px;
  margin-bottom: 30px;
}

.btn-auth {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 22px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
}

/* --- 主体区域优化 --- */
.concept-main {
  padding: 80px 0;
}

.page-card {
  border-radius: $radius;
  border: none;
  box-shadow: none;
  background: transparent;

  :deep(.el-card__body) {
    padding: 0;
  }
}

.page-card-inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.modern-card {
  background: #fff;
  border-radius: $radius;
  padding: 40px;
  border: 1px solid $border;
  box-shadow: $shadow;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.08);
  }
}

.evaluation-grid {
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 32px;
  align-items: start;
}

.evaluation-grid--single {
  grid-template-columns: 1fr;
}

/* 左侧信息卡片 */
.info-section {
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  h2 {
    font-size: 26px;
    font-weight: 700;
    color: $text-dark;
    margin: 0;
  }
}

.header-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #10b981; /* 绿色 */
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.5);

  &--blue {
    background: $primary;
    box-shadow: 0 0 12px rgba(37, 99, 235, 0.5);
  }
}

.clean-list {
  list-style: none;
  padding: 0;
  margin: 0 0 32px;

  li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 16px;

    i {
      color: #10b981;
      font-size: 18px;
      margin-top: 4px;
    }

    span {
      font-size: 17px;
      line-height: 1.6;
      color: $text-light;
    }
  }
}

.divider-line {
  height: 1px;
  background: linear-gradient(90deg, transparent, $border, transparent);
  margin-bottom: 24px;
}

.mini-charts-grid {
  margin: 8px 0 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.mini-chart-item {
  border: 1px solid $border;
  background: #ffffff;
  border-radius: 14px;
  padding: 12px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.04);

  span {
    font-size: 15px;
    font-weight: 600;
    color: $text-dark;
    white-space: nowrap;
  }
}

.chart-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 1px solid #eef2ff;
  color: $primary;

  svg {
    width: 26px;
    height: 26px;
    display: block;
  }
}

.chart-icon--bar {
  color: #10b981;
}

.chart-icon--trend {
  color: #f59e0b;
}

.value-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 8px;
}

.value-item {
  background: $bg-body;
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    background: #fff;
    border-color: rgba($primary, 0.2);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  }
}

.value-icon {
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  color: $primary;

  .value-svg {
    width: 24px;
    height: 24px;
    display: block;
  }

  i {
    font-size: 20px;
    color: $primary;
  }
}

.value-text {
  h4 {
    margin: 0 0 2px;
    font-size: 16px;
    font-weight: 700;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: $text-light;
  }
}

@media (max-width: 1024px) {
  .mini-charts-grid {
    grid-template-columns: 1fr;
  }
  .mini-chart-item {
    justify-content: flex-start;
  }
  .value-grid {
    grid-template-columns: 1fr;
  }
}

.card-paragraph {
  font-size: 17px;
  line-height: 1.8;
  color: $text-light;
}

/* 右侧表单卡片 */
.form-section {
  background: #fff;
}

.form-header-group {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
}

.form-icon-box {
  width: 52px;
  height: 52px;
  background: $primary-light;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 24px;
    color: $primary;
  }
}

.form-title-text {
  h3 {
    margin: 0 0 4px;
    font-size: 24px;
    font-weight: 700;
  }

  p {
    margin: 0;
    font-size: 15px;
    color: $text-light;
  }
}

/* 表单内部控件 */
.clean-form {
  :deep(.el-form-item) {
    margin-bottom: 20px;
  }

  :deep(.el-form-item__label) {
    font-size: 16px;
    font-weight: 600;
    color: $text-dark;
    padding-bottom: 8px;
    line-height: 1;
  }

  :deep(.el-input__inner), :deep(.el-textarea__inner) {
    background: #fdfdfd !important;
    border: 1px solid $border !important;
    padding: 12px 16px !important;
    border-radius: 10px !important;
    font-size: 16px !important;
    color: $text-dark !important;
    transition: all 0.2s ease !important;

    &::placeholder {
      color: #cbd5e1;
    }

    &:focus {
      background: #fff !important;
      border-color: $primary !important;
      box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.08) !important;
    }
  }
}

.input-with-extra {
  display: flex;
  align-items: center;
  gap: 12px;

  .el-input {
    flex: 1;
  }
}

.input-badge {
  background: #f0fdf4;
  color: #166534;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 8px;
  white-space: nowrap;
}

.premium-button {
  width: 100%;
  height: 56px;
  background: linear-gradient(135deg, $primary, #1d4ed8);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 12px 24px -8px rgba(37, 99, 235, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.guide-card {
  margin-top: 24px;
  border-radius: $radius;
  border: 1px solid $border;
  box-shadow: $shadow;

  :deep(.el-card__body) {
    padding: 32px 40px;
  }
}

/* --- 结果与加载 --- */
.loading-container {
  padding: 60px 0;
}

.loadingGif {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.loading-text {
  font-size: 20px;
  font-weight: 700;
  margin-top: 20px;
}

.loading-subtext {
  font-size: 16px;
  color: $text-light;
  margin-top: 8px;
}

.report-status {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  color: #10b981;
  margin-bottom: 24px;

  i {
    font-size: 22px;
  }
}

.action-btn {
  background: #fff;
  border: 1px solid $border;
  padding: 10px 30px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    border-color: $primary;
    color: $primary;
  }
}

/* --- 历史记录列表 --- */
.history-content {
  background: #fff;
  border-radius: $radius;
  padding: 40px;
  box-shadow: $shadow;
}

.history-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 30px;

  i {
    color: $primary;
    font-size: 22px;
  }
}

.custom-table {
  :deep(th) {
    background: #f8fafc !important;
    color: $text-dark;
    font-weight: 700;
    padding: 16px 0;
  }

  :deep(td) {
    padding: 12px 0;
  }
}

.pagination-container {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

/* --- 页脚样式 --- */
.modern-footer {
  background: #0f172a;
  color: #94a3b8;
  padding: 60px 0;
  margin-top: 80px;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-addr {
  margin: 0 0 12px;
  font-size: 16px;
}

.footer-meta {
  display: flex;
  gap: 16px;
  font-size: 15px;

  .sep {
    color: #334155;
  }
}

.footer-col.right {
  text-align: right;

  p {
    margin: 0 0 8px;
    font-size: 15px;
  }
}

/* 动画 */
.fade-in {
  animation: fadeIn 0.6s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1024px) {
  .evaluation-grid {
    grid-template-columns: 1fr;
  }
  .banner_box {
    aspect-ratio: auto;
    min-height: 300px;
  }
}
</style>
